import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Intersection } from '@splidejs/splide-extension-intersection';
import '@splidejs/splide/css';

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.wp-block-create-block-slider');

    sliders.forEach((container) => {
        const slider = container.querySelector('.splide');
        const track = slider?.querySelector('.splide__track');
        const list = slider?.querySelector('.splide__list');

        const arrows = slider?.querySelectorAll('.splide__arrow');
        // const pagination = slider?.querySelectorAll('.splide__pagination');
        const paginations = slider?.querySelectorAll('.splide__pagination__page');


        if (arrows) {
            arrows.forEach((arrow) => {
                arrow.style.backgroundColor = container.dataset.arrowBackgroundColor || 'transparent';
                const svg = arrow.querySelector('svg');
                if (svg) {
                    svg.style.fill = container.dataset.arrowIconColor || 'currentColor';
                }
            });
        }

        if (paginations) {
            paginations.forEach((pagination) => {
                pagination.style.background = container.dataset.paginationColor || 'transparent';

                if (pagination.classList.contains("is-active")) {
                    pagination.style.backgroundColor = container.dataset.paginationActiveColor || 'currentColor';
                }
            });
        }


        if (slider && track && list) {
            const slidesPerPage = parseInt(container.dataset.slidesPerPage) || 2;
            const slidesPerPageTablet = parseInt(container.dataset.slidesPerPageTablet) || slidesPerPage;
            const slidesPerPageMobile = parseInt(container.dataset.slidesPerPageMobile) || 1;
            const gap = container.style.gap || '1rem';
            const type = container.dataset.type || 'loop';
            const pagination = container.dataset.pagination === 'true';
            const arrows = container.dataset.arrows === 'true';
            const padding = container.dataset.padding || '0%';
            const autoScroll = container.dataset.autoscroll === 'true';
            const autoPlay = container.dataset.autoplay === 'true';
            const autoScrollSpeed = parseInt(container.dataset.autoscrollspeed) || 1;
            const pauseOnHover = container.dataset.pauseonhover === 'true';
            const drag = container.dataset.drag === 'true';
            const autoPlayInterval = parseInt(container.dataset.autoplayinterval) || 5000;
            const autoPlaySpeed = parseInt(container.dataset.autoplayspeed) || 500;
            const autoPlayHover = container.dataset.autoplayhover === 'true';
            // Correggi il nome dell'attributo

            const options = {
                perPage: slidesPerPage,
                gap: gap,
                type: type,
                pagination: pagination,
                arrows: arrows,
                padding: padding,
                drag: drag,
                autoplay: autoPlay,
                perMove: 1,
                interval: autoPlayInterval,
                speed: autoPlaySpeed,
                pauseOnHover: autoPlayHover,
                rewind: type == "fade" ? true : false,
                breakpoints: {
                    1024: { perPage: slidesPerPageTablet },
                    768: { perPage: slidesPerPageMobile },
                },
            };

            if (autoScroll) {
                options.autoScroll = {
                    speed: autoScrollSpeed,
                    pauseOnHover: pauseOnHover,
                };
            }

            window.splides = window.splides || [];

            const splide = new Splide(slider, options);

            
            slider.splide = splide;
            window.splides.push(splide);



            if (autoScroll) {
                splide.mount({ AutoScroll, Intersection });
            } else {
                splide.mount();
            }
        } else {
            console.error('Elementi Splide mancanti in:', container);
        }
    });
});